import { createMuiStyles } from '../../../utils/mui';

export const mobileHeaderStyles = createMuiStyles({
  logo: {
    textDecoration: 'none',
    mx: 'auto',
    fontWeight: 'Bold',
    color: 'secondary.main',
    display: 'block',
    img: {
      height: '3.5rem',
      width: 'auto',
    },
  },
  drawerProfileBtn: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    textDecoration: 'none',
    height: 'auto',
  },
  drawerSignInBtn: {
    flexDirection: 'column',
    display: 'block',
    height: 'auto',
  },
  menuLink: {
    fontSize: '0.875rem',
    '&.active': {
      color: 'primary.main',
    },
    '.MuiTypography-root': {
      fontSize: 'inherit',
    },
  },
});
